import objectAssign from 'object-assign';


export function video( state = { 
	post: {},
	fetching: {
		post: false
	}
}, action ) {

	switch( action.type ) {

		case 'REQUEST_VIDEO':
			return Object.assign({}, state, {
				post: {},
				fetching: Object.assign({}, state.fetching, {post: true}),
			})

		case 'RECEIVE_VIDEO':
			return Object.assign({}, state, {
				post: action.video,
				fetching: Object.assign({}, state.fetching, {post: false}),
			})

		default:
			return state;

	}
	
}



// WEBPACK FOOTER //
// ./src/js/reducers/video.js